module.exports = __webpack_public_path__ + "static/media/google.d66762e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomComponents/SignIn/Google/images/google.svg
// module id = 1304
// module chunks = 6 7 8